export const getAppVersion = (pathname) => {
  const URL_STRING_TO_ARRAY = pathname.split('/');
  return URL_STRING_TO_ARRAY.includes('v2') ? '/v2' : '';
};
